
import { daysOfTheWeek } from "../elements/Days";
import { renderFormattedDate } from "../helpers/FormatDate";
import { renderPerformanceLink } from "../helpers/PerformanceLink";
import { renderLegend } from "../helpers/RenderLegend";

export const renderWeekly = (calendar) => {

	let performances = limelight.performances;
    let calText = '';
	let weeklyNumberDays = limelight.data.weekly_shown_days ?? 7;
    let todayDate = new Date();
    let startCustom = false;
    let weekday = daysOfTheWeek('ddd');

    // If user selects start date && before today
    let commence = todayDate <= startCustom ? startCustom : todayDate;
    let thisDay = new Date(commence);

	// Display the legend
	if (calendar.dataset.layout == 'legend_top') {
		calText += `<div class="calendar__header calendar__header--weekly">${renderLegend()}</div>`;
	}

    // Generates weekday names
    calText += '<div class="calendar__grid-container">';
	calText += '<div class="days">';
    for (let i = thisDay.getDay(); i < thisDay.getDay() + 7; i++) {
        let the_day = i;
        if (the_day > 6) {
            the_day = the_day - 7;
        }
        calText += '<div class="day">' + weekday[the_day] + '</div>';
    }
    calText += '</div>';

    // Generates Day
	calText += '<div class="calendar__grid">';
    for (let j = 0; j < weeklyNumberDays; j++) {

        const newDate = new Date(thisDay);
        let thisRenderedDate = new Date( newDate.setDate(newDate.getDate() + j) );		

        calText +=
            `<div class="day-box day-box--perf">
				<div class="day-box-inner">
					<div class="box-date">
						<time>
							${ renderFormattedDate(thisRenderedDate, limelight.data.weekly_date_format) }
						</time>
					</div>
					<div class="performance-holder">
						${renderPerformanceLink(thisRenderedDate, performances)}
					</div>
				</div>
            </div>`;
    }

    calText += '</div</div>'; // end .grid and end .grid-container

	// Display the legend
	if (calendar.dataset.layout == 'legend_bottom') {
		calText += `<div class="calendar__footer calendar__footer--weekly">${renderLegend()}</div>`;
	}

    calendar.innerHTML += calText; 

    calText = '';

}
